<template>
    <li
        class="list-item"
    >
        <div class="player-edit-section">
            <div class="title">
                <a
                    href="#"
                    @click.prevent="$emit('click', {
                        editPlayerType: 'archive',
                        player: player,
                    })"
                >
                    {{ player.name }}
                    <base-icon
                        class="is-small edit-icon"
                        icon="pencil-alt"
                    />
                </a>
                <base-icon
                    class="is-small is-gray trash-icon"
                    icon="trash"
                    @click="playerDelete('archive', player.hash)"
                />
                <base-label
                    v-if="player.sticky"
                    class="is-small is-green"
                >
                    Sticky
                </base-label>
            </div>
        </div>
        <embed-button
            player-type="archive"
            :player="player"
            @click="value => $emit('click', value)"
        />
    </li>
</template>

<script>
import EmbedButton from './EmbedButton';
import { mapActions } from 'vuex';

export default {
    components: {
        EmbedButton,
    },

    props: {
        player: {
            type: Object,
            required: true,
        },
        show: {
            type: Object,
            required: true,
        },
    },

    /**
     * Before destroy hook
     */
    beforeDestroy() {
        this.$emit('player-delete', false);
    },

    methods: {
        ...mapActions(['deletePlayer']),

        /**
         * Delete player
         *
         * @param   {string}  type  Player type
         * @param   {string}  hash  Player hash
         *
         */
        async playerDelete(type, hash) {
            this.$emit('player-delete', true);

            try {
                await this.deletePlayer({ type, showHash: this.show.hash, playerHash: hash });
            } catch (e) {
                this.$emit('error', 'We could\'t delete your player. Please try again later or contact us.');
                this.$emit('player-delete', false);
            }
        },
    },
};
</script>
